import * as angular from "angular";
import * as _ from "lodash"

angular
  .module('bringoz.admin.commons')
  .filter('bringozVolume', bringozVolume);

function bringozVolume(splitService, $filter) {
  return function packageVolumeFilter(volume, enableUnitDisplay, defaultValue) {
    const siteUnit = splitService.getVolumeUnit();

    if (_.isUndefined(volume)) {
      return defaultValue || '--'
    }

    const volumeUnit = $filter('translate')(siteUnit);
    return _.round(volume, 2) + (enableUnitDisplay ? (' ' + volumeUnit) : '');
  }
}
